import { FilterInput } from '@apeiron/common'
import { ConstellationFilterInput } from '@apeiron/star'
import { styled } from '@mui/material'
import BlurForm from '@src/components/share/filter/BlurForm'
import RangeSlider from '@src/components/share/filter/RangeSlider'
import useFetchStarFilterJson from '@src/hooks/json/useFetchStarFilterJson'
import * as R from 'ramda'
import { FC, useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const StyledRangeSlider = styled(RangeSlider)`
  .Custom-Number-Input {
    background-color: #262626;
  }
`

const ConstellationStarCountFilter: FC<Props> = (props: Props) => {
  const { className, filterInput, onFilterChange } = props

  const { t } = useTranslation()

  const { data: filterData } = useFetchStarFilterJson()

  const [min, setMin] = useState(0)

  const [max, setMax] = useState(0)

  const handleOnValueChange = useCallback(
    (filter: FilterInput) => {
      if (onFilterChange) {
        onFilterChange(filter as ConstellationFilterInput)
      }
    },
    [onFilterChange]
  )

  useEffect(() => {
    if (R.isNotNil(filterData)) {
      setMin(filterData?.starFilterConstellations.minStarCount)
      setMax(filterData?.starFilterConstellations.maxStarCount)
    }
  }, [filterData])

  return (
    <BlurForm>
      <StyledRangeSlider
        className={className}
        filterOptions={filterInput}
        labelText={t('star.list.filter.constellation.filter_star_count')}
        max={max}
        maxValueKey={'maxStarCount'}
        min={min}
        minValueKey={'minStarCount'}
        onFilterOptionsChange={handleOnValueChange}
      />
    </BlurForm>
  )
}

export type Props = {
  className?: string
  filterInput: ConstellationFilterInput
  onFilterChange: (filterInput: ConstellationFilterInput) => void
}

export default ConstellationStarCountFilter
